export const FIXED_DEPOSIT_VALIDATION_MESSAGES = {
  min: 'Fixed deposit must be greater than or equal to 0% of the job total',
  max: 'Fixed deposit must be less than or equal to 75% of the job total',
};

export const QUOTE_FIXED_DEPOSIT_VALIDATION_MESSAGES = {
  min: 'Fixed deposit must be greater than or equal to 0% of the job total',
  max: 'Fixed deposit must be less than or equal to 75% of the job total',
};
